<dual-currency-modal
    [currentCurrency]="currentCurrency"
    [alternativeCurrency]="alternativeCurrency"
    [texts]="texts"
    [size]="size"
    (currencySelected)="onCurrencySelected($event)"
>
</dual-currency-modal>
